import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import AppRoutes from "./Routes";
import config from "./config";
import { useAuth } from "./contexts/AuthContext";

Sentry.init({
  dsn: config.sentry_dsn || undefined,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [config.api_url],
    }),
  ],
  environment: config.sentry_env,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.4,
  replaysOnErrorSampleRate: 1.0,
});

function App() {
  const { apiUser } = useAuth();

  useEffect(() => {
    if (apiUser) {
      Sentry.setUser({
        id: apiUser.id,
        email: apiUser.email,
        username: `${apiUser.first_name} ${apiUser.last_name}`,
      });
    }
  }, [apiUser]);

  return <AppRoutes />;
}

export default App;
